import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicClaimantRefDto extends EpimsBaseEntityDto {
  ClaimantName: string;
  CommunityId: string;

  SubscriptionUserId: string;
  Version: number;
}
